import React from 'react';
import UserProfile from 'user/normal/pages/profile/index';
import "styles/scss/doctor/pages/profile.scss";

const Index = (props) => {
  return(
    <div id="DoctorProfile">
      <UserProfile
        {...props}
      />
    </div>
  )
}


export default Index;
      
